

module.exports = __webpack_require__.stylable.create(
    "AvatarGroup1622370820",
    {"classes":{"root":"AvatarGroup1622370820__root","avatars":"AvatarGroup1622370820__avatars","avatarContainer":"AvatarGroup1622370820__avatarContainer","avatar":"AvatarGroup1622370820__avatar","textButtonContainer":"AvatarGroup1622370820__textButtonContainer","textButton":"AvatarGroup1622370820__textButton"},"vars":{},"stVars":{"DefaultAvatarBorderColor":"color-1","AvatarBorderColor":"--overridable","TextButtonFont":"--overridable","TextButtonColor":"--overridable","avatarBorderColorValue":"\"fallback(--overridable, color-1)\"","SmallerTextButtonFont":"\"{theme: 'Body-M', size: '14px', lineHeight: '1.44em'}\""},"keyframes":{}},
    "",
    8,
    "AvatarGroup1622370820",
    null
);
